import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StarsIcon = function StarsIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "84",
    height: "16",
    viewBox: "0 0 84 16",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8 0L10.116 5.08754L15.6085 5.52786L11.4238 9.11246L12.7023 14.4721L8 11.6L3.29772 14.4721L4.5762 9.11246L0.391548 5.52786L5.88397 5.08754L8 0Z",
      fill: "#FF7E00"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25 0L27.116 5.08754L32.6085 5.52786L28.4238 9.11246L29.7023 14.4721L25 11.6L20.2977 14.4721L21.5762 9.11246L17.3915 5.52786L22.884 5.08754L25 0Z",
      fill: "#FF7E00"
    }), /*#__PURE__*/_jsx("path", {
      d: "M42 0L44.116 5.08754L49.6085 5.52786L45.4238 9.11246L46.7023 14.4721L42 11.6L37.2977 14.4721L38.5762 9.11246L34.3915 5.52786L39.884 5.08754L42 0Z",
      fill: "#FF7E00"
    }), /*#__PURE__*/_jsx("path", {
      d: "M59 0L61.116 5.08754L66.6085 5.52786L62.4238 9.11246L63.7023 14.4721L59 11.6L54.2977 14.4721L55.5762 9.11246L51.3915 5.52786L56.884 5.08754L59 0Z",
      fill: "#FF7E00"
    }), /*#__PURE__*/_jsx("path", {
      d: "M76 0L78.116 5.08754L83.6085 5.52786L79.4238 9.11246L80.7023 14.4721L76 11.6L71.2977 14.4721L72.5762 9.11246L68.3915 5.52786L73.884 5.08754L76 0Z",
      fill: "#FF7E00"
    })]
  });
};